var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["keyword"],
                            expression: "['keyword']",
                          },
                        ],
                        staticStyle: {
                          width: "250px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: {
                          placeholder: "请输入版本号/开发商/固件上传人",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["deviceModel"],
                              expression: "['deviceModel']",
                            },
                          ],
                          staticStyle: { width: "150px" },
                          attrs: {
                            placeholder: "请选择型号",
                            optionFilterProp: "children",
                            "show-search": "",
                          },
                        },
                        _vm._l(_vm.DeviceSelect, function (el) {
                          return _c(
                            "a-select-option",
                            { key: el.id, attrs: { value: el.id } },
                            [_vm._v(_vm._s(el.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["updateType"],
                              expression: "['updateType']",
                            },
                          ],
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "请选择更新设备类型" },
                        },
                        _vm._l(_vm.updateType, function (el) {
                          return _c(
                            "a-select-option",
                            { key: el.id, attrs: { value: el.value } },
                            [_vm._v(_vm._s(el.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "deviceModel",
              fn: function (record) {
                return [
                  _vm._v(" " + _vm._s(_vm.getDeviceModelName(record)) + " "),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: 800,
            destroyOnClose: "",
            maskClosable: false,
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 5 },
                "wrapper-col": { span: 18 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "设备型号", prop: "deviceModel" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择设备型号",
                        "has-feedback": "",
                        autocomplete: "off",
                        optionFilterProp: "children",
                        "show-search": "",
                      },
                      model: {
                        value: _vm.ruleForm.deviceModel,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "deviceModel", $$v)
                        },
                        expression: "ruleForm.deviceModel",
                      },
                    },
                    _vm._l(_vm.DeviceSelect, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.id, attrs: { value: el.id } },
                        [_vm._v(_vm._s(el.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "更新设备类型", prop: "updateType" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择更新设备类型",
                        "has-feedback": "",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.ruleForm.updateType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "updateType", $$v)
                        },
                        expression: "ruleForm.updateType",
                      },
                    },
                    _vm._l(_vm.updateType, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.id, attrs: { value: el.value } },
                        [_vm._v(_vm._s(el.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "固件升级类型", prop: "sellitemmenu" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择固件升级类型" },
                      model: {
                        value: _vm.ruleForm.sellitemmenu,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "sellitemmenu", $$v)
                        },
                        expression: "ruleForm.sellitemmenu",
                      },
                    },
                    _vm._l(_vm.sellitemmenuArray, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.label, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本号", prop: "versionCode" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入版本号 x.x.x",
                      disabled: !_vm.nowTitleIsNew,
                    },
                    model: {
                      value: _vm.ruleForm.versionCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionCode", $$v)
                      },
                      expression: "ruleForm.versionCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "开发商", prop: "developer" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入开发商",
                      disabled: "",
                    },
                    model: {
                      value: _vm.ruleForm.developer,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "developer", $$v)
                      },
                      expression: "ruleForm.developer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "更新包大小", prop: "packageSize" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请上传更新包",
                      disabled: "",
                    },
                    model: {
                      value: _vm.ruleForm.packageSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "packageSize", $$v)
                      },
                      expression: "ruleForm.packageSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "上传更新包", prop: "downloadUrl" } },
                [
                  _c(
                    "a-upload",
                    {
                      staticClass: "m-upload",
                      attrs: {
                        name: "avatar",
                        "before-upload": _vm.beforeUpload,
                        remove: _vm.remove,
                        "file-list": _vm.files,
                        disabled: !_vm.nowTitleIsNew,
                      },
                      model: {
                        value: _vm.ruleForm.downloadUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "downloadUrl", $$v)
                        },
                        expression: "ruleForm.downloadUrl",
                      },
                    },
                    [
                      _vm.files.length <= 0
                        ? _c("a-icon", {
                            attrs: { type: _vm.upLoading ? "loading" : "plus" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "上市时间", prop: "marketDate" } },
                [
                  _c("a-date-picker", {
                    attrs: { format: _vm.dateFormat },
                    model: {
                      value: _vm.ruleForm.marketDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "marketDate", $$v)
                      },
                      expression: "ruleForm.marketDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "更新说明", prop: "updateLog" } },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入更新说明",
                      rows: 4,
                      maxLength: 2048,
                    },
                    model: {
                      value: _vm.ruleForm.updateLog,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "updateLog", $$v)
                      },
                      expression: "ruleForm.updateLog",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "版本详细说明（富文本）",
                    prop: "versionDetailRichText",
                  },
                },
                [
                  _vm.visible
                    ? _c("edit-components", {
                        attrs: {
                          content: _vm.ruleForm.versionDetailRichText,
                          "html-change": _vm.onVersionDetailRichTextChange,
                          uploadImg: _vm.uploadRichTextImg,
                          "upload-path": _vm.richTextUploadPath,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }